import { Box } from "@mui/material";
import React from "react";
import ChartsSection from "../components/charts/ChartsSection";
import ChartsDrawer from "../components/charts/ChartsDrawer";
import { DrawerProvider, useDrawerActions } from "../context/DrawerContext";
import { useChartCards } from "../hooks/useChartCards";

const InsightsPageContent = () => {
  const { openDrawer } = useDrawerActions();
  const { charts, loadingCharts, reloadCharts } = useChartCards();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        sx={{ py: 2.5, gap: 2.5, minHeight: "100%" }}
      >
        <ChartsSection
          handleAddClick={() => openDrawer("insights", "add")}
          charts={charts}
          loadingCharts={loadingCharts}
          reloadCharts={reloadCharts}
        />
      </Box>
      <ChartsDrawer reloadCharts={reloadCharts} />
    </>
  );
};

/**
 * The provider wraps the page's own tree rather than sitting in App.tsx: App renders one page from a
 * switch, so this page unmounts on tab navigation and the drawer state resets with it.
 */
const InsightsPage = () => (
  <DrawerProvider>
    <InsightsPageContent />
  </DrawerProvider>
);

export default InsightsPage;
